"use client";

import IncomingOrderView from "@shared/src/components/modules/quick-trade/IncomingOrderView";
import { SignInModal } from "@shared/src/components/common/dialogs/SignInModal";
import { NetworkSelector } from "@shared/src/components/common/form-components/NetworkSelector";
import { ModalAlert } from "@shared/src/components/common/misc/ModalAlert";
import { useBlockchainStore } from "@shared/src/stores/useBlockchainStore";
import { useModalStore } from "@shared/src/stores/useModalStore";

export function ModalManager() {
  const modalStore = useModalStore();

  const { isCorrectChain } = useBlockchainStore();

  return (
    <>
      <ModalAlert
        {...modalStore}
        onOpenChange={e => {
          console.log("onOpenChange", e);
          if (!e) modalStore?.closeModal();
        }}
      />
      <SignInModal />
      {modalStore.networkModalOpen && (
        <NetworkSelector
          title={!isCorrectChain ? "Unsupported Network" : undefined}
          description="Select a network from the options below to continue"
          preventClose={!isCorrectChain}
          className="hidden"
          modal
          initialOpen={true}
        />
      )}
      <IncomingOrderView />
    </>
  );
}
